import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import addLogDocument from "../addLogDocument"; // Assuming you have this utility for logging
import { checkDB } from "../../models/DataFunctions";

const stripeCheckoutSession = async (
  oid,
  product_type = "signature",
  quantity,
  token,
  prefix
) => {
  // Define the endpoint URL
  const url = prefix + "stripe/create-checkout-session";

  // Define the request body
  const body = {
    oid: oid,
    product_type: product_type,
    engagement: "none",
    quantity: quantity,
    mode: "payment",
  };

  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the POST request using fetch
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });
    const auth = getAuthCentral();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      return "User not logged in";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return;
    }

    const org_id = userSnapshot.get("org_id");

    const responseData = await response.json();

    // Add log document
    await addLogDocument(
      url,
      prefix,
      userRef,
      org_id,
      response.status.toString(),
      "",
      "",
      JSON.stringify(body),
      JSON.stringify(responseData) // log the response data as a string
    );

    // Check if the request was successful
    if (response.ok) {
      const checkoutUrl = responseData.url || "";
      return checkoutUrl;
    } else {
      console.error(`Failed to create checkout session: ${response.status}`);
      return "";
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
};

export default stripeCheckoutSession;
